import { render, staticRenderFns } from "./checkDetailLegacy.vue?vue&type=template&id=4301e3ba&scoped=true"
import script from "./checkDetailLegacy.vue?vue&type=script&lang=js"
export * from "./checkDetailLegacy.vue?vue&type=script&lang=js"
import style0 from "./checkDetailLegacy.vue?vue&type=style&index=0&id=4301e3ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4301e3ba",
  null
  
)

export default component.exports